import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import axios from "axios";
import { AnchorComponent, ButtonComponent } from "../../../components/elements";
import { Modal, Row, Col, Form, Table } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import '../App/modalstyle.css';

export default function PetBreedsIndex() {
    const { t } = useContext(TranslatorContext);

    const AuthToken = localStorage.getItem("authToken")

    const [data, setData] = useState([]);
    const [parentBreeds, setParentBreeds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [alertModal, setAlertModal] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    // Store Modal States
    const [storeModal, setStoreModal] = useState(false);
    const [storeForm, setStoreForm] = useState({
        name: '',
        parent_id: ''
    });
    const [storeErrors, setStoreErrors] = useState({});
    const [storeLoading, setStoreLoading] = useState(false);

    // Update Modal States
    const [updateModal, setUpdateModal] = useState(false);
    const [updateForm, setUpdateForm] = useState({
        id: null,
        name: '',
        parent_id: ''
    });
    const [updateErrors, setUpdateErrors] = useState({});
    const [updateLoading, setUpdateLoading] = useState(false);

    useEffect(() => {
        fetchBreeds();
    }, []);

    const fetchBreeds = () => {
        setLoading(true);

        axios.get(`${process.env.REACT_APP_API_URL}/pet-breeds`, {
            headers: {
                Authorization: `Bearer ${AuthToken}`
            }
        })
            .then(res => setData(res.data.breed))
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    };

    // ---------------- STORE ----------------
    const openStoreModal = () => {
        setStoreForm({ name: '', parent_id: '' });
        setStoreErrors({});
        setStoreModal(true);
        fetchParentBreeds();
    };

    const handleStoreChange = (e) => {
        const { name, value } = e.target;
        setStoreForm(prev => ({ ...prev, [name]: value }));
        if (storeErrors[name]) {
            setStoreErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleStoreSubmit = async (e) => {
        e.preventDefault();
        setStoreLoading(true);
        setStoreErrors({});

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/pet-breeds`,
                storeForm,
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`
                    }
                }
            );

            if (response.data.success) {
                fetchBreeds();
                setStoreModal(false);
                setStoreForm({ name: '', parent_id: '' });

                // Success toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Breed added successfully!',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } catch (error) {
            if (error.response?.status === 422) {
                setStoreErrors(error.response.data.errors || {});

                // Error toast for validation
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Validation error!',
                    text: 'Please check the form fields.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            } else {
                // General error toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Error!',
                    text: 'Failed to add breed. Please try again.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } finally {
            setStoreLoading(false);
        }
    };

    // ---------------- UPDATE ----------------
    const openUpdateModal = async (item) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/pet-breeds-edit/${item.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`
                    }
                }
            );

            setUpdateForm({
                id: res.data.breed.id,
                name: res.data.breed.name,
                parent_id: res.data.breed.parent_id || ''
            });

            setParentBreeds(res.data.parentBreeds);
            setUpdateErrors({});
            setUpdateModal(true);

        } catch (err) {
            console.error(err);

            // Error toast for fetch failure
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Error!',
                text: 'Failed to load breed data.',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });
        }
    };

    const handleUpdateChange = (e) => {
        const { name, value } = e.target;
        setUpdateForm(prev => ({ ...prev, [name]: value }));
        if (updateErrors[name]) {
            setUpdateErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        setUpdateLoading(true);
        setUpdateErrors({});

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/pet-breeds-update/${updateForm.id}`,
                {
                    name: updateForm.name,
                    parent_id: updateForm.parent_id
                },
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`
                    }
                }
            );

            if (response.data.success) {
                fetchBreeds();
                setUpdateModal(false);

                // Success toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Breed updated successfully!',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } catch (error) {
            if (error.response?.status === 422) {
                setUpdateErrors(error.response.data.errors || {});

                // Error toast for validation
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Validation error!',
                    text: 'Please check the form fields.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            } else {
                // General error toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Error!',
                    text: 'Failed to update breed. Please try again.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } finally {
            setUpdateLoading(false);
        }
    };

    // ---------------- FETCH PARENTS ----------------
    const fetchParentBreeds = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/pet-breeds`);
            setParentBreeds(res.data.breed.filter(b => !b.parent_id));
        } catch (err) {
            console.error(err);
        }
    };

    const handleDelete = (id) => {
        console.log("Delete breed ID:", id);

        // Delete confirmation with SweetAlert
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Show loading toast
                    Swal.fire({
                        title: 'Deleting...',
                        text: 'Please wait',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });

                    // Make delete API call here
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/pet-breeds/${id}`,
                        {
                            headers: {
                                Authorization: `Bearer ${AuthToken}`
                            }
                        }
                    );

                    if (response.data.success) {
                        fetchBreeds();

                        // Success toast
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'success',
                            title: 'Breed deleted successfully!',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true
                        });
                    }
                } catch (error) {
                    Swal.close();

                    // Error toast
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'error',
                        title: 'Error!',
                        text: 'Failed to delete breed. Please try again.',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true
                    });
                }
            }
        });

        setAlertModal(false);
    };

    if (loading) return <PageLayout><p>{t("loading")}...</p></PageLayout>;

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">{t('pet breeds')}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t('home')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t('pet breeds')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">{t('list')}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">

                        <div className="mc-card-header d-flex justify-content-between align-items-center p-3">
                            <h5 className="mc-card-title mb-0">{t('pet breeds list')}</h5>
                            <ButtonComponent
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={openStoreModal}
                            >
                                <i className="material-icons">add</i>
                                {t('add breed')}
                            </ButtonComponent>
                        </div>

                        <Row>
                            <Col xl={12}>
                                <div className="mc-card">
                                    <div className="table-responsive-wrapper">
                                        <Table responsive className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th><p>#</p></th>
                                                    <th>{t('name')}</th>
                                                    <th>{t('parent')}</th>
                                                    <th>{t('actions')}</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {data.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td><p>{index + 1}</p></td>
                                                        <td>{item.name}</td>
                                                        <td>{item.parent_breed?.name || '-'}</td>
                                                        <td>
                                                            <div className="mc-table-action">
                                                                <ButtonComponent
                                                                    className="material-icons edit"
                                                                    onClick={() => openUpdateModal(item)}
                                                                >
                                                                    edit
                                                                </ButtonComponent>

                                                                {/* <ButtonComponent
                                                                    className="material-icons delete"
                                                                    onClick={() => {
                                                                        setCurrentId(item.id);
                                                                        handleDelete(item.id);
                                                                    }}
                                                                >
                                                                    delete
                                                                </ButtonComponent> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            {/* STORE MODAL */}
            <Modal show={storeModal} onHide={() => setStoreModal(false)} centered dialogClassName="custom-modal-dialog"
                contentClassName="custom-modal-content">

                <Modal.Header closeButton className="p-3">
                    <Modal.Title>{t('add breed')}</Modal.Title>
                </Modal.Header>

                <Form onSubmit={handleStoreSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>{t('name')} *</Form.Label>
                            <Form.Control
                                name="name"
                                value={storeForm.name}
                                onChange={handleStoreChange}
                                isInvalid={!!storeErrors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {storeErrors.name?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{t('parent')}</Form.Label>
                            <Form.Select
                                name="parent_id"
                                value={storeForm.parent_id}
                                onChange={handleStoreChange}
                            >
                                <option value="">None</option>
                                {parentBreeds.map(p => (
                                    <option key={p.id} value={p.id}>{p.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer className="p-3">
                        <ButtonComponent className="btn btn-secondary" onClick={() => setStoreModal(false)}>
                            {t('cancel')}
                        </ButtonComponent>

                        <ButtonComponent className="btn btn-primary" type="submit" disabled={storeLoading}>
                            {storeLoading && <span className="spinner-border spinner-border-sm me-2"></span>}
                            {t('save')}
                        </ButtonComponent>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* UPDATE MODAL */}
            <Modal show={updateModal} onHide={() => setUpdateModal(false)} centered dialogClassName="custom-modal-dialog"
                contentClassName="custom-modal-content">

                <Modal.Header closeButton className="p-3">
                    <Modal.Title>{t('edit breed')}</Modal.Title>
                </Modal.Header>

                <Form onSubmit={handleUpdateSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>{t('name')} *</Form.Label>
                            <Form.Control
                                name="name"
                                value={updateForm.name}
                                onChange={handleUpdateChange}
                                isInvalid={!!updateErrors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {updateErrors.name?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{t('parent')}</Form.Label>
                            <Form.Select
                                name="parent_id"
                                value={updateForm.parent_id}
                                onChange={handleUpdateChange}
                            >
                                <option value="">None</option>
                                {parentBreeds.map(p => (
                                    <option key={p.id} value={p.id}>{p.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer className="p-3">
                        <ButtonComponent className="btn btn-secondary" onClick={() => setUpdateModal(false)}>
                            {t('cancel')}
                        </ButtonComponent>

                        <ButtonComponent className="btn btn-primary" type="submit" disabled={updateLoading}>
                            {updateLoading && <span className="spinner-border spinner-border-sm me-2"></span>}
                            {t('update')}
                        </ButtonComponent>
                    </Modal.Footer>
                </Form>
            </Modal>
        </PageLayout>
    );
}